<template>
  <header :class="$options.name">
    <figure :class="$options.name + '__image'">
      <img v-if="img" :alt="alt" :src="img + '?fm=jpg&fl=progressive&w=2560&q=75'">
      <Loader v-else/>
    </figure>
    <figcaption :class="$options.name + '__text'">
      <slot/>
    </figcaption>
  </header>
</template>
<script>
import Loader from "@/components/Loader";
export default {
  name: "Hero",
  components: { Loader },
  computed: {
    overlay() {
      if (this.$slots.default) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    alt: { default: "Image description"},
    img: { default: "" }
  }
};
</script>
<style lang="scss">
@keyframes slideDown {
  from {
    transform: translateY(rem(64));
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideUp {
  from {
    transform: translateY(rem(-64));
  }
  to {
    transform: translateX(0);
  }
}
.Hero {
  background-color: var(--contrast);
  text-align: center;
  &__image,
  &__text {
    @include smooth;
    animation-duration: 0.75s;
    animation-timing-function: cubic-bezier(0.25, 0.5, 0.5, 1.125);
  }
  &__image {
    animation-name: slideDown;
    img { width: 100%; }
  }
  &__text {
    align-items: center;
    animation-name: slideUp;
    background-color: var(--contrast);
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    padding: rem(32);
    text-align: center;
    width: 100%;
    > *,
    .RichText > * {
      max-width: rem(960);
      width: 100%;
      + * {
        margin-top: rem(16);
      }
    }
  }
}
</style>